import { DEFAULT_BORDER } from 'constants/global';
import { defaultReviewsPropsData } from './defaultData';

import NDA from 'assets/icons/companiesLogos/nda.svg';

const cardsData = [
  {
    companyIcon: NDA,
    text: 'Проект состоялся благодаря слаженной работе команды ASTON. Мы ценим их ответственность, умение быстро адаптироваться и внимательное отношение к нашим комментариям. Все обязательства выполнены полностью и в срок',
    position: 'Руководитель отдела разработки',
  },
  {
    companyIcon: NDA,
    text: 'Мы ценим профессионализм команды и её внимание к клиенту. Общение было чётким и по делу, поэтому работа получилась продуктивной',
    position: 'Ведущий специалист',
  },
];

const slidesStyles = [
  { bgColor: 'bg.neonLight', iconProps: { bgSize: '55%' } },
  {
    border: DEFAULT_BORDER,
    borderColor: 'line.gray',
    iconProps: { bgSize: '55%', bgColor: 'bg.gray' },
  },
];

export const oilAndGasReviewsPropsData = {
  titleProps: {
    fontSize: { mobile: '28px', tablet: '36px', laptop: '64px', desktop: '48px' },
  },
  cardsData: [...cardsData, ...defaultReviewsPropsData.cardsData],
  slidesStyles: [...slidesStyles, ...defaultReviewsPropsData.slidesStyles],
};
